import { createAction } from '@reduxjs/toolkit';
import { DetectionGap } from '../models';

export const PLAY_GAP_IN_VIDEO = createAction<PlayGapInVideoRequest>(
  'media-details-faces-gaps/PLAY_GAP_IN_VIDEO'
);

export type PlayGapInVideoRequest = DetectionGap;
export const actionPlayGapInVideo = (payload: PlayGapInVideoRequest) =>
  PLAY_GAP_IN_VIDEO(payload);
